<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 11v-5M12 11 6.5 17M12 11l5.5 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<circle cx="12" cy="4.5" r="1.7" stroke="currentColor" stroke-width="1.6"/>
<circle cx="6" cy="18.5" r="1.7" stroke="currentColor" stroke-width="1.6"/>
<circle cx="18" cy="18.5" r="1.7" stroke="currentColor" stroke-width="1.6"/>
</svg>
</template>
